// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { FormControlLabel, Switch } from '@mui/material';
import { Factors } from './factors';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@advisor-app/store/store';
import { selectUniverseEsgFactors } from '@advisor-app/store/slices/available-parameters';
import {
  selectUniverseFilters,
  setEsgFactors,
  updateUniverseFilters,
} from '@advisor-app/store/slices/parameters';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

export const EsgScreener: FC<{ id: string }> = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const universe = useAppSelector(state => selectUniverseFilters(state, id))!;
  const { esg_scoring: esgFactors, esg_not_informed: esgNotInformed } = universe;

  const esgFactorsNames = useAppSelector(selectUniverseEsgFactors);

  const handleEsgNotInformedChange = (value: boolean) => {
    dispatch(updateUniverseFilters([id, { esg_not_informed: value }]));
  };

  return (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={esgNotInformed}
            onChange={event => handleEsgNotInformedChange(event.target.checked)}
          />
        }
        label={t('research.include-not-informed', { ns: 'research' })}
        labelPlacement="start"
        className="mb-2 ml-2.5"
        classes={{ label: '!text-subtitle' }}
      />
      <div className="mt-4 px-2">
        <Factors
          names={esgFactorsNames}
          states={esgFactors}
          setFactors={factors => setEsgFactors([id, factors])}
          testId="esg-factors"
        />
      </div>
    </>
  );
};
